// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"skeleton_skeleton__jifZq"};